// extracted by mini-css-extract-plugin
export var icon = "_aq-3";
export var subtitle = "_aq-2";
export var title = "_aq-1";
export var value = "_aq-0";